import React from 'react'

function FinalCta() {
  return (
    <section className="bg-[#EBD9C3] py-24 md:py-32">
      <div className="max-w-[800px] mx-auto px-6 md:px-10 text-center animate-fade-up">
        <h2 className="font-display text-[#49352B] text-4xl md:text-6xl font-bold mb-6 leading-tight">
          Volte a sentir o prazer de colocar pão quentinho na mesa da sua família
        </h2>
        <p className="text-[#49352B]/70 text-lg md:text-xl mb-10">
          Comece hoje com o Método Massa Perfeita™ e descubra que comer saudável pode ser tão gostoso quanto sempre deveria ter sido.
        </p>
        <a
          href="https://app.klumify.com.br/produto/ad3f29ec-d4d7-425b-b4c2-35d9324a6c0b"
          className="inline-block h-[68px] px-12 flex items-center justify-center bg-[#D9891B] hover:bg-[#c17a15] text-white text-lg font-semibold rounded-[18px] transition-all duration-300 transform hover:scale-105 shadow-[0_20px_40px_-10px_rgba(217,137,27,0.5)] hover:shadow-[0_24px_48px_-8px_rgba(217,137,27,0.65)]"
        >
          QUERO TRANSFORMAR MINHA ALIMENTAÇÃO
        </a>
        <p className="mt-6 text-sm text-[#49352B]/60 font-medium">
          Acesso imediato • Garantia de 7 dias • Compra segura
        </p>
      </div>
    </section>
  )
}

export default FinalCta
